import defaultsDeep from '~/utils/defaultsDeepES';
import defaults from './defaults';
import overrides from './overrides';



export default defaultsDeep(overrides, defaults) as typeof defaults;
